import _FormControl from "@material-ui/core/esm/FormControl";
import _Select from "@material-ui/core/esm/Select";
import _MenuItem from "@material-ui/core/esm/MenuItem";
import _InputBase from "@material-ui/core/esm/InputBase";
import _InputLabel from "@material-ui/core/esm/InputLabel";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { COUNTRY_CODES, USA_STATES_LIST } from 'swag-common/constants/shipping.constants';
import responsiveSelectClasses from 'swag-client-common/components/partials/payment-details/form-country-picker/form-country-picker.scss';
import fixedSelectClasses from 'swag-client-common/components/partials/payment-details/form-country-picker/form-country-picker-fixed.scss';
import responsiveBaseInputClasses from '../form-styled-input-base/form-styled-input-base.scss';
import fixedBaseInputClasses from '../form-styled-input-base/form-styled-input-base-fixed.scss';
import StyledInput from '../styled-input/styled-input';
import responsiveClasses from './form-state-picker.scss';
import fixedClasses from './form-state-picker-fixed.scss';
const FormStateSelect = _ref => {
  let {
      input,
      isFixedStyles = false
    } = _ref,
    custom = _objectWithoutProperties(_ref, ["input", "isFixedStyles"]);
  const classes = isFixedStyles ? fixedClasses : responsiveClasses;
  const selectClasses = isFixedStyles ? fixedSelectClasses : responsiveSelectClasses;
  const baseInputClasses = isFixedStyles ? fixedBaseInputClasses : responsiveBaseInputClasses;
  const MenuProps = {
    classes: {
      list: classes.menuItemList
    }
  };
  const classesRoot = {
    root: selectClasses.root,
    icon: selectClasses.icon
  };
  const inputLabelClasses = {
    root: classes.labelRoot,
    shrink: classes.shrink,
    formControl: classes.formControl
  };
  const menuItemClasses = {
    root: selectClasses.menuItem
  };
  const baseClasses = {
    input: baseInputClasses.input,
    root: baseInputClasses.root
  };
  return /*#__PURE__*/React.createElement(_FormControl, {
    classes: classesRoot
  }, !input.value && /*#__PURE__*/React.createElement(_InputLabel, {
    classes: inputLabelClasses,
    disableAnimation: true,
    focused: false,
    shrink: !!custom.state
  }, custom.placeholder), /*#__PURE__*/React.createElement("select", {
    "data-select": "StatePicker",
    value: input.value,
    onChange: input.onChange,
    className: classes.select
  }, /*#__PURE__*/React.createElement("option", {
    key: "",
    value: ""
  }, custom.placeholder), USA_STATES_LIST.map(({
    code,
    name
  }) => /*#__PURE__*/React.createElement("option", {
    key: code,
    value: code
  }, name, " (", code, ")"))), /*#__PURE__*/React.createElement(_Select, _extends({
    autoWidth: true
  }, input, custom, {
    input: /*#__PURE__*/React.createElement(_InputBase, {
      classes: baseClasses
    }),
    MenuProps: MenuProps,
    className: selectClasses.select
  }), USA_STATES_LIST.map(({
    code,
    name
  }) => /*#__PURE__*/React.createElement(_MenuItem, {
    classes: menuItemClasses,
    value: code
  }, name, " (", code, ")"))));
};
export const FormStatePicker = _ref2 => {
  let {
      input,
      label,
      country,
      children,
      isFixedStyles = false
    } = _ref2,
    custom = _objectWithoutProperties(_ref2, ["input", "label", "country", "children", "isFixedStyles"]);
  if (country === COUNTRY_CODES.US) {
    return /*#__PURE__*/React.createElement(FormStateSelect, _extends({
      isFixedStyles: isFixedStyles,
      input: input,
      label: label
    }, custom), children);
  }
  return /*#__PURE__*/React.createElement(StyledInput, _extends({
    isFixedStyles: isFixedStyles,
    input: input,
    label: label
  }, custom), children);
};